import React from 'react';
import { Flex, Typography, Skeleton } from 'antd';
import { AreaChart, Area, Tooltip, ResponsiveContainer } from 'recharts';
import ChangeIndicator from './ChangeIndicator';
import ActiveDot from 'components/charts/components/ActiveDot';
import Ninja from '@ninja';

const { Text } = Typography;

const TrafficReportingOverviewCard = ({
  totals,
  isLoading,
  title,
  format,
  metricKey,
  dataKey,
  data,
  change,
}) => {
  return (
    <div
      size='small'
      className='mx-1 shadow-sm my-2 h-full rounded-md p-1'
      style={{ border: '1px solid #e5e5e5de', height: 120 }}
    >
      <Skeleton paragraph={{ rows: 4 }} title={0} active loading={isLoading}>
        <div className='w-full px-2'>
          <Text className='text-xs font-medium'>{title}</Text>
          <Flex align='center' gap='small'>
            <Text className='text-3xl font-medium'>
              {format ? format(totals?.[metricKey]) : totals?.[metricKey]}
            </Text>
            {change !== undefined && <ChangeIndicator change={change} />}
          </Flex>
        </div>
        {!data?.length ? (
          <Typography className='text-xs font-normal text-color-light w-full flex flex-col mt-2 justify-center items-center h-fit'>
            No data found for this date range.
          </Typography>
        ) : (
          <ResponsiveContainer width='100%' height={50}>
            <AreaChart
              data={data}
              margin={{
                top: 5,
                right: 0,
                left: 0,
              }}
            >
              <Tooltip
                cursor={{
                  stroke: '#007bffcc',
                  strokeWidth: 1,
                  strokeDasharray: '3 3',
                }}
                content={({ active, payload }) => {
                  if (active && payload && payload.length) {
                    return (
                      <div className='border-radius bg-white rounded-md px-2 py-2 shadow-lg'>
                        <Flex align='center' gap='middle'>
                          <span className='font-normal text-sm flex justify-center'>
                            {new Date(payload[0].payload?.date).toLocaleDateString('en-US', {
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric',
                            })}
                            :
                          </span>

                          {payload.map((entry, index) => (
                            <Text className='font-bold text-sm' key={index}>
                              {format(entry.value ?? entry.payload?.value)}
                            </Text>
                          ))}
                        </Flex>
                      </div>
                    );
                  }
                  return null;
                }}
              />
              <defs>
                <linearGradient id='blueGradient' x1='0' y1='1' x2='0' y2='0'>
                  <stop offset='0%' stopColor='#d4e9ffcc' stopOpacity={0.6} />
                  <stop offset='100%' stopColor='#007bffcc' stopOpacity={0.6} />
                </linearGradient>
              </defs>

              <Area
                type='linear'
                dataKey={dataKey}
                stroke='#2c7df0'
                strokeWidth={1}
                fill='url(#blueGradient)'
                activeDot={<ActiveDot />}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </Skeleton>
    </div>
  );
};

export default TrafficReportingOverviewCard;
